import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// import { update_current_question } from './'
// import { try_force_logoff } from '../auth'

const update_question_request = () => {
  return {
    type: questionsTypes.update.request
  }
}

const update_question_success = (response) => {
  return {
    type: questionsTypes.update.success,
    payload: response.data.question
  }
}

const update_question_failure = (messages) => {
  return {
    type: questionsTypes.update.failure,
    payload: messages
  }
}

const update_question = (question_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_question_request())

    // Request
    axios.patch(
      formatRoute(QUESTIONS_ROUTES.update, {id: question_id}),
      values
    ).then( response => {
      // success
      dispatch( update_question_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating question."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( update_question_failure(errors))
    })
  }

}

export {
  update_question
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/update.js